import React from 'react';

interface Tab {
  id: string;
  label: string;
}

interface PlatformEditorTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export default function PlatformEditorTabs({ tabs, activeTab, onTabChange }: PlatformEditorTabsProps) {
  return (
    <div className="border-b bg-gray-50">
      <div className="flex space-x-1 px-4 py-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-4 py-2 rounded-t-lg text-sm font-medium transition-colors ${
              activeTab === tab.id
                ? 'bg-white text-blue-600 border-l border-t border-r border-gray-200 -mb-px'
                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-100'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}